export default __webpack_public_path__ + "src/images/packages/zannier-hotels-sonop/96e79fab44b7a24e9d0867614d3d8a1f-1.jpg";